import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
export const ColumnSize = ['xs', 'sm', 'md', 'lg'];
const getClasses = props => cx(ColumnSize.reduce((obj, size) => ({
  ...obj,
  [`col-${size}-${props[size]}`]: typeof props[size] === 'number',
  [`col-${size}`]: typeof props[size] === 'boolean' && props[size],
  [`col-${size}-content`]: props[size] === 'content',
  [`col-${size}-offset-${props[`${size}Offset`]}`]: typeof props[`${size}Offset`] === 'number',
  [`${props[`${size}Order`]}-${size}`]: !!props[`${size}Order`],
  [`${props[`${size}HorizontalAlign`]}-${size}`]: !!props[`${size}HorizontalAlign`]
}), {}));
export default function Column({
  children,
  className = null,
  ...props
}) {
  const {
    xs,
    sm,
    md,
    lg,
    xsOffset,
    smOffset,
    mdOffset,
    lgOffset,
    xsOrder,
    smOrder,
    mdOrder,
    lgOrder,
    xsHorizontalAlign,
    smHorizontalAlign,
    mdHorizontalAlign,
    lgHorizontalAlign,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(className, getClasses(props))
  }, rest), children);
}

// boolean, number, or "content"
const size = (props, propName, componentName) => {
  const value = props[propName];
  if (value == null || typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string' && value === 'content') {
    return;
  }

  /* istanbul ignore next */
  // eslint-disable-next-line consistent-return
  return new Error(`Invalid prop "${propName}" supplied to "${componentName}". Validation failed.`);
};
const order = PropTypes.oneOf(['first', 'last']);
const horizontalAlign = PropTypes.oneOf(['start', 'center', 'end', 'middle']);
Column.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  xs: size,
  sm: size,
  md: size,
  lg: size,
  xsOffset: PropTypes.number,
  smOffset: PropTypes.number,
  mdOffset: PropTypes.number,
  lgOffset: PropTypes.number,
  xsOrder: order,
  smOrder: order,
  mdOrder: order,
  lgOrder: order,
  xsHorizontalAlign: horizontalAlign,
  smHorizontalAlign: horizontalAlign,
  mdHorizontalAlign: horizontalAlign,
  lgHorizontalAlign: horizontalAlign
};
//# sourceMappingURL=index.js.map